import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-perf-help-modal',
  templateUrl: './perf-help-modal.component.pug',
  styleUrls: ['./perf-help-modal.component.scss'],
  standalone: false
})
export class PerfHelpModalComponent implements OnInit {

  @Input() request;
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(public _bsModalRef: BsModalRef, public permissionService: PermissionsService) {
  }

  ngOnInit(): void {
    this.ENT_10363_PULSE_RELAUNCH = this.permissionService.isFeatureActivated('ent-10363-pulse-relaunch');
  }

  close() {
    this._bsModalRef.hide();
  }

}
